import { useLang } from "@/i18n";

export const Marquee = ({ dark = false }) => {
  const { t } = useLang();
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "border-white/10 bg-ink text-white/50" : "border-ink/10 bg-bone text-ink/50"}`}
    >
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((i) => (
          <span
            key={i}
            aria-hidden={i === 1}
            className="font-mono text-[11px] uppercase tracking-[0.45em] py-5 pr-4"
          >
            {t.marquee.repeat(3)}
          </span>
        ))}
      </div>
    </div>
  );
};
